<script >
const __sfc_main = {};
__sfc_main.props = {
  alertDraft: {
    type: Object,
    required: true
  },
  alertsResource: {
    type: Object,
    default: () => ({})
  },
  pendingAlerts: {
    type: Array,
    default: () => []
  },
  executedAlerts: {
    type: Array,
    default: () => []
  },
  isSubmittingAlert: {
    type: Boolean,
    default: false
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const alertFieldOptions = [{
    value: 'valor_actual',
    label: 'Cotización'
  }, {
    value: 'soport',
    label: 'Soporte'
  }, {
    value: 'entrada',
    label: 'Entrada'
  }, {
    value: 'out_price',
    label: 'Stop'
  }, {
    value: 'entry_distance',
    label: 'Distancia entrada'
  }];
  const alertModeOptions = [{
    value: '<',
    label: 'Menor que'
  }, {
    value: '=',
    label: 'Igual a'
  }, {
    value: '>',
    label: 'Mayor que'
  }];
  const emitAlertDraft = nextDraft => {
    emit('update:alert-draft', {
      ...props.alertDraft,
      ...nextDraft
    });
  };
  const selectField = value => {
    emitAlertDraft({
      field: value
    });
    emit('select-alert-field', value);
  };
  return {
    emit,
    alertFieldOptions,
    alertModeOptions,
    emitAlertDraft,
    selectField
  };
};
export default __sfc_main;
</script>

<template>
    <div class="charting-workspace-inspector__panel-body">
        <div class="charting-workspace-inspector__summary-cell">
            <div class="charting-workspace-inspector__summary-label">Crear alarma</div>
            <div class="mt-3 grid gap-3">
                <select :value="alertDraft.field" class="charting-workspace-inspector__select" @change="selectField($event.target.value)">
                    <option v-for="option in alertFieldOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
                <select :value="alertDraft.mode" class="charting-workspace-inspector__select" @change="emitAlertDraft({ mode: $event.target.value })">
                    <option v-for="option in alertModeOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
                <InputText :model-value="alertDraft.value" inputmode="decimal" placeholder="Introduce un valor" @update:model-value="emitAlertDraft({ value: $event })" />
                <Button label="Guardar alarma" icon="pi pi-bell" :loading="isSubmittingAlert" @click="emit('create-alert')" />
            </div>
        </div>

        <div class="charting-workspace-inspector__summary-cell">
            <div class="charting-workspace-inspector__summary-label">Pendientes</div>
            <div v-if="alertsResource.isLoading && alertsResource.isLoading.value" class="charting-workspace-inspector__loader">
                <ProgressSpinner style="width: 28px; height: 28px" stroke-width="6" />
            </div>
            <div v-else-if="pendingAlerts.length" class="mt-3 flex flex-col gap-3">
                <div v-for="alert in pendingAlerts" :key="alert.id" class="charting-workspace-inspector__event">
                    <div class="flex items-start justify-between gap-3">
                        <div>
                            <div class="text-sm font-semibold text-surface-900 dark:text-surface-0">{{ alert.fieldLabel }} {{ alert.modeLabel }} {{ alert.value }}</div>
                            <div class="mt-1 text-xs text-muted-color">{{ alert.createdLabel || 'Fecha no disponible' }}</div>
                        </div>
                        <Button icon="pi pi-trash" severity="danger" text rounded :loading="isSubmittingAlert" @click="emit('remove-alert', alert.id)" />
                    </div>
                </div>
            </div>
            <div v-else class="mt-3 text-sm text-muted-color">No hay alarmas pendientes para este ticker.</div>
        </div>

        <div class="charting-workspace-inspector__summary-cell">
            <div class="charting-workspace-inspector__summary-label">Ejecutadas</div>
            <div v-if="executedAlerts.length" class="mt-3 flex flex-col gap-3">
                <div v-for="alert in executedAlerts" :key="`done-${alert.id}`" class="charting-workspace-inspector__event">
                    <div class="text-sm font-semibold text-surface-900 dark:text-surface-0">{{ alert.fieldLabel }} {{ alert.modeLabel }} {{ alert.value }}</div>
                    <div class="mt-1 text-xs text-muted-color">Creada {{ alert.createdLabel || 'N/D' }} · Ejecutada {{ alert.executedLabel || 'N/D' }}</div>
                </div>
            </div>
            <div v-else class="mt-3 text-sm text-muted-color">No hay alarmas ejecutadas para este ticker.</div>
        </div>
    </div>
</template>
